/*
  Quick JS by Jason @ freakdesign.
  Questions? Ping me on twitter: @freakdesign
  Relates to blog post:
  https://freakdesign.com.au/blogs/news/get-shipping-estimates-on-a-product-page
  Example:
  https://jasons-experiments.myshopify.com/products/alex-twill-pant-mariner
*/

/* 
PARA INSTALAR: carregue os scripts abaixo no theme.liquid
    <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery.mask/1.14.16/jquery.mask.min.js"></script>
    <script src="{{ 'quickShipping.js' | asset_url }}" defer="defer"></script>
*/

(function () {

  "use strict";

  /* Mude para TRUE caso queira debugar o código */
  var debug = true;
  var cartCookie;

  /* logger com controle por flag */
  function log(a) { if (debug) console.log(a); }

  /* ID do elemento para adicionar os campos de frete */
  var productSection = document.getElementsByClassName('frete-produto');
  if (!productSection.length) { log('Could not find the element'); return }

  /* Elemento do botão (não é select) e variant selecionada via window */
  var productSelect = document.querySelector('.product-buy-buttons__add-to-cart');
  // Captura o valor do input com name="id" e ref="variantId"
var selectedVariantId = document.querySelector('input[name="id"][ref="variantId"]')?.value || null;


  log(productSelect);
  if (!productSelect) { productSelect = document.getElementsByName('id')[0]; }
  if (!productSelect) { log('Could not find the main select element'); return }

  /* Cria os campos de frete dentro da DIV selecionada anteriormente */
  var shippingMessage = document.createElement('p');
  var shippingCountry = document.createElement('select');
  var shippingProvince = document.createElement('select');
  var shippingZip = document.createElement('input');
  var freteLista = document.createElement('div');

  /* Erro Frete */
  shippingMessage.classList.add('erros-fretes');
  shippingMessage.setAttribute("style", "display:none");

  /* Ajustes da lista de fretes */
  freteLista.classList.add('listas-de-fretes');
  freteLista.setAttribute("style", "display:none");

  /* --------- HELPERS NOVOS PARA ESTIMATIVA --------- */
  function formatDateBR(iso) {
    if (!iso) return null;
    // força meio-dia pra evitar timezone estranhos
    var d = new Date(iso + 'T12:00:00');
    if (isNaN(d)) return null;
    return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }

  function buildEstimate(rate) {
    // 1) range completo
    if (Array.isArray(rate.delivery_range) && rate.delivery_range.length === 2 && rate.delivery_range[0] && rate.delivery_range[1]) {
      var a = rate.delivery_range[0], b = rate.delivery_range[1];
      if (a === b) return 'Entrega prevista: ' + formatDateBR(a);
      return 'Entrega prevista: ' + formatDateBR(a) + ' — ' + formatDateBR(b);
    }

    // 2) data única
    if (rate.delivery_date) {
      return 'Entrega prevista: ' + formatDateBR(rate.delivery_date);
    }

    // 3) dias (mín./máx.)
    if (Array.isArray(rate.delivery_days) && rate.delivery_days.length) {
      var min = rate.delivery_days[0];
      var max = (rate.delivery_days.length > 1 && rate.delivery_days[1] != null) ? rate.delivery_days[1] : min;
      return (min === max)
        ? ('Entrega em até ' + max + ' dias')
        : ('Entrega entre ' + min + ' e ' + max + ' dias');
    }

    // 4) fallback
    return 'Estimativa de entrega indisponível';
  }

  function formatBRL(value) {
    if (value == null || value === "0.00") return "Grátis";
    var num = parseFloat(value);
    if (isNaN(num)) return "R$ " + value;
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(num);
  }
  /* --------- FIM HELPERS --------- */

  /* We are just adding some dummy fields for example only. There's better ways to handle this */
  var initFields = function () {

      /* create the country picker */
      shippingCountry.id = "pais-simulator";

      var countries = ['Brazil'];
      for (var i = 0; i < countries.length; i++) {
          shippingCountry.add(new Option(countries[i], countries[i], i === 0));
      };
      shippingCountry.name = 'shipping_address[country]';

      /* create the province state picker */
      shippingProvince.id = "estados-simulator";

      var provinces = ['Acre', 'Alagoas', 'Amapa', 'Amazonas', 'Bahia', 'Ceara', 'Distrito Federal', 'Espirito Santo', 'Goias', 'Maranhao', 'Mato Grosso', 'Mato Grosso do Sul', 'Minas Gerais', 'Para', 'Paraiba', 'Parana', 'Pernambuco', 'Piaui', 'Rio de Janeiro', 'Rio Grande do Norte', 'Rio Grande do Sul', 'Rondonia', 'Roraima', 'Santa Catarina', 'Sao Paulo', 'Sergipe', 'Tocantins'];
      for (var i = 0; i < provinces.length; i++) {
          shippingProvince.add(new Option(provinces[i], provinces[i], i === 0));
      };
      shippingProvince.name = 'shipping_address[province]';

      /* create the zip / postcode field */
      shippingZip.type = 'text';
      shippingZip.name = 'shipping_address[zip]';
      shippingZip.className = 'Form__Input cep-calculo-frete form-control';
      shippingZip.placeholder = 'DIGITE SEU CEP';
      $(shippingZip).mask("00.000-000")

      /* wrappers */
      var shippingCalcWrapper = document.createElement('div');
      shippingCalcWrapper.className = 'shipping-calc-wrapper';

      var formularioFrete = document.createElement('div');
      formularioFrete.className = 'formulario-frete';

      /* título (opcional) */
      var shippingCalcTitle = document.createElement('p');
      shippingCalcTitle.innerText = 'Simule seu frete';

      /* botão calcular */
      var shippingCalcButton = document.createElement('a');
      shippingCalcButton.innerText = 'Calcular';
      shippingCalcButton.className = 'btn btn-underline button--primary button';
      shippingCalcButton.onclick = function () {

          var cepLimpo = shippingZip.value.replace(/\D/g, '');
          log(cepLimpo);

          shippingMessage.innerHTML = '';
          shippingMessage.setAttribute("style", "display:none");

          $.getJSON("https://viacep.com.br/ws/" + cepLimpo + "/json/?callback=?", function (dados) {

              if (!("erro" in dados)) {

                  switch (dados.uf) {
                      case 'AC': dados.uf = 'Acre'; break;
                      case 'AL': dados.uf = 'Alagoas'; break;
                      case 'AP': dados.uf = 'Amapa'; break;
                      case 'AM': dados.uf = 'Amazonas'; break;
                      case 'BA': dados.uf = 'Bahia'; break;
                      case 'CE': dados.uf = 'Ceara'; break;
                      case 'DF': dados.uf = 'Distrito Federal'; break;
                      case 'ES': dados.uf = 'Espirito Santo'; break;
                      case 'GO': dados.uf = 'Goias'; break;
                      case 'MA': dados.uf = 'Maranhao'; break;
                      case 'MT': dados.uf = 'Mato Grosso'; break;
                      case 'MS': dados.uf = 'Mato Grosso do Sul'; break;
                      case 'MG': dados.uf = 'Minas Gerais'; break;
                      case 'PA': dados.uf = 'Para'; break;
                      case 'PB': dados.uf = 'Paraiba'; break;
                      case 'PR': dados.uf = 'Parana'; break;
                      case 'PE': dados.uf = 'Pernambuco'; break;
                      case 'PI': dados.uf = 'Piaui'; break;
                      case 'RJ': dados.uf = 'Rio de Janeiro'; break;
                      case 'RN': dados.uf = 'Rio Grande do Norte'; break;
                      case 'RS': dados.uf = 'Rio Grande do Sul'; break;
                      case 'RO': dados.uf = 'Rondonia'; break;
                      case 'RR': dados.uf = 'Roraima'; break;
                      case 'SC': dados.uf = 'Santa Catarina'; break;
                      case 'SP': dados.uf = 'Sao Paulo'; break;
                      case 'SE': dados.uf = 'Sergipe'; break;
                      case 'TO': dados.uf = 'Tocantins'; break;
                  };

                  shippingProvince.value = dados.uf;

                  // cookies do carrinho
                  cartCookie = getCookie('cart');
                  var tempCookieValue = tempCookieValue || "temp-cart-cookie___" + Date.now();
                  var fakeCookieValue = fakeCookieValue || "fake-cart-cookie___" + Date.now();

                  if (!cartCookie) {
                      log('no cookie found');
                      updateCartCookie(tempCookieValue);
                      cartCookie = getCookie('cart');
                  } else {
                      log('cookie found');
                  }

                  if (cartCookie.length < 32) { log('cart ID not valid'); return }

                  // troca cookie pra forçar cálculo
                  updateCartCookie(fakeCookieValue);
                  log(getCookie('cart'));
                  
                  // usa a variant selecionada do window
                  if (selectedVariantId) {
                    getRates(parseInt(selectedVariantId));
                    return false;
                  }
                  return false;

              }
          }).fail(function () {
              $('.listas-de-fretes').html("");
              shippingMessage.innerHTML = 'Cep não encontrado, tente novamente.';
              shippingMessage.setAttribute("style", "display:flex");
          });

      };

      /* labels (se quiser usar) */
      var labelNames = ['País', 'Estado', 'CEP'];
      var labels = [];
      for (var i = 0; i < labelNames.length; i++) {
          var label = document.createElement('label');
          label.innerText = labelNames[i];
          labels.push(label);
      };

      shippingCalcWrapper.appendChild(formularioFrete);
      // shippingCalcWrapper.appendChild(shippingCalcTitle); // opcional

      formularioFrete.appendChild(shippingCountry);
      formularioFrete.appendChild(shippingProvince);
      formularioFrete.appendChild(shippingZip);
      formularioFrete.appendChild(shippingCalcButton);
      shippingCalcWrapper.appendChild(shippingMessage);
      shippingCalcWrapper.appendChild(freteLista);

      /* add to the page */
      productSection[0].appendChild(shippingCalcWrapper);

  };

  /* get cookie by name */
  var getCookie = function (name) {
      var value = "; " + document.cookie;
      var parts = value.split('; ' + name + '=');
      if (parts.length == 2) return parts.pop().split(";").shift();
  };

  /* update the cart cookie value */
  var updateCartCookie = function (a) {
      log('changing cart cookie value to: ' + a);
      var date = new Date();
      date.setTime(date.getTime() + (14 * 86400000));
      var expires = '; expires=' + date.toGMTString();
      document.cookie = 'cart=' + a + expires + '; path=/';
  };

  /* reset the cart cookie value */
  var resetCartCookie = function () {
      updateCartCookie(cartCookie);
      log(getCookie('cart'));
  };

  /* get the rates */
  var getRates = function (variantId) {
    console.log('testeee');

      $('.listas-de-fretes').html("");
      $('.listas-de-fretes').show();

      if (typeof variantId === 'undefined') { return }

      var productQuantity = document.getElementById('Quantity');
      var quantity = productQuantity ? parseInt(productQuantity.value) : 1;

      var addData = {
          'id': variantId,
          'quantity': quantity
      };

      log(addData);

      fetch('/cart/add.js', {
          body: JSON.stringify(addData),
          credentials: 'same-origin',
          headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'xmlhttprequest'
          },
          method: 'POST'
      }).then(function (response) {
          return response.json();
      }).then(function (json) {
          log(json);
      
          $.ajax({
              type: "GET",
              url: '/cart/shipping_rates.json',
              data: {
                  'shipping_address[country]': shippingCountry.value,
                  'shipping_address[province]': shippingProvince.value,
                  'shipping_address[zip]': shippingZip.value
              },
              beforeSend: function () {
                  $('.listas-de-fretes').html("<img id='loading-icon-frete' src='https://cdn.shopify.com/s/files/1/0698/5852/5417/files/loading-buffering.webp' width='30px' style='width:30px; height: 30px; margin:0 auto'>");
              },
              success: function (d) {
                  log(d);
                  if (d.shipping_rates && d.shipping_rates.length) {

                      for (var i = 0; i < d.shipping_rates.length; i++) {
                          var rate = d.shipping_rates[i];

                          // estimativa baseada no response (delivery_range / delivery_date / delivery_days)
                          var entrega = buildEstimate(rate);

                          // preço em BRL (ou Grátis)
                          var valorFrete = formatBRL(rate.price);

                          // usa 'presentment_name' se existir, senão 'name'
                          var nomeFrete = rate.presentment_name || rate.name || 'Frete';

                          $('<div class="frete-item">' +
                              '<div>' +
                                '<p class="m-0 nome-frete">' +
                                  '<b><span class="frete-item-head" style="font-size: 14px; font-weight: 400;">' + nomeFrete + '</span></b> ' +
                                  '<span class="estimativa-de-entrega">' + entrega + '</span>' +
                                '</p>' +
                              '</div>' +
                              '<div class="frete-valor" style="font-size: 14px; font-weight: 400;">' +
                                'Valor: <b><span class="frete-item-head" style="font-weight: 400;">' + valorFrete + '</span></b>' +
                              '</div>' +
                            '</div>').appendTo('.listas-de-fretes');
                      }

                      $('#loading-icon-frete').remove();
                      log("Removido");
                  } else {
                      $('.listas-de-fretes').html("<p>Opss, não encontramos fretes disponíveis para este cep, tente novamente.</p>");
                  }
                  resetCartCookie();
                  $('#loading-icon-frete').remove();
                  log("Removido");
              },
              error: function () {
                  resetCartCookie();
                  $('.listas-de-fretes').html("");
                  shippingMessage.innerHTML = 'Cep não encontrado, tente novamente.';
                  shippingMessage.setAttribute("style", "display:flex");
              },
              dataType: 'json'
          }).fail(function () {
              alert("fail");
          })
      }).catch(function (err) {
          console.error(err);
          resetCartCookie()
      });

  };

  initFields();
  
})();
